const ViewTier = ({ data }) => {
    const { tierName, orderNo, courseList } = data;

    return (
        <>
            <h5 className="mb-3">Tier Information</h5>
            <div className="info-table">
                <div className="row info-table__tr mb-2">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">
                                <label>Name</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{tierName}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">
                                <label>Order No</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{orderNo}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-table__tr mb-2">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-4">
                                <label>Course List</label>
                            </div>
                            <div className="col-8">
                                <div className="table_value_pre">
                                    <strong>{}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                {courseList && courseList.nodes && courseList.nodes.length > 0 ? (
                                    <ol className="mb-0">
                                        {courseList.nodes.map((item, index) => (
                                            <li
                                                className={`${index !== courseList.nodes.length - 1 ? "mb-2" : ""}`}
                                                key={item.courseId}
                                            >
                                                {item.courseName}
                                            </li>
                                        ))}
                                    </ol>
                                ) : (
                                    <p className="text-danger mb-0">No Courses Found!</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewTier;
